import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IMembership } from "./clubProfile/CreditPackage";
import { getPlayersAllMemberships } from "../Api/api";
import { CgSpinner } from "react-icons/cg";
import { AuthContext } from "./AuthProvider";
import { MembershipCard } from "./MembershipCard";

export const Memberships = () => {
    const currentUser = useContext(AuthContext);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [memberships, setMemberships] = useState<IMembership[]>([]);

    useEffect(() => {
        let isMounted = true;

        const fetchMembership = async () => {
            setLoading(true);

            try {
                const data = await getPlayersAllMemberships();

                if (isMounted && data) {
                    setMemberships(data);
                }
            } catch (error) {
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchMembership();

        return () => {
            isMounted = false;
        };
    }, [refresh]);

    return (
        <div className="py-8 px-4">
            {!currentUser ? (
                <button
                    className="hover:underline"
                    onClick={() => navigate("/sign-in")}
                >
                    {t("loginToCheckMemberships")}
                </button>
            ) : (
                <>
                    {loading ? (
                        <div className="flex justify-center items-center mt-10">
                            <CgSpinner className="animate-spin text-[24px]" />
                        </div>
                    ) : (
                        <div className="flex flex-row flex-wrap gap-4 justify-center">
                            {memberships && memberships.length ? (
                                memberships.map((membership: any) => (
                                    <MembershipCard key={membership._id} membership={membership} memberships={memberships} setMemberships={setMemberships} refresh={refresh} setRefresh={setRefresh} />
                                ))
                            ) : (
                                <p className="text-[15px]">
                                    {t("noMembershipsAvailable")}
                                </p>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
